export const FORM_NAME = 'loginForm';

export const ACTION_PREFIX = 'auth';
